import SelectableButtonGroup from './_selectable-button-group.js'
import FlexPane from './_flex-pane.js'
import Button from './_button.js'
import Text from './_text.js'
import TeaserOptions from './_teaser-options.js'
import SingleBetsList from './_single-bets-list.js'
import BetslipSettings from './_betslip-settings.js'
import SystemBetsList from './_system-bets-list.js'
import ToggleButton from './_toggle-button.js'

export default {
  name: 'BetBuilder',
  values: {
    showBetslipSettings: true,
    showTeasers: false,
    showBankers: false,
    showGroupedSingles: true,
    tabs: {
      configSet: SelectableButtonGroup,
      configValues: {
        selectableButton: {
          unselected: {
            style: {
              base: {
                flexBasis: '0px',
                lineHeight: '40px',
              },
            },
          },
          selected: {
            style: {
              base: {
                flexBasis: '0px',
                lineHeight: '40px',
              },
            },
          },
        },
      },
    },
    topContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
        },
      },
    },
    contentContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
        },
      },
    },
    teaserOptionsAndSinglesContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
        },
      },
    },
    removeAllButton: {
      configSet: Button,
      configValues: {
        inline: true,
        style: {
          base: {
            flexGrow: 0,
            minHeight: '40px',
            alignItems: 'center',
          },
        },
      },
    },
    removeAllButtonText: {
      configSet: Text,
      configValues: {
        container: {
          padding: '0 8px',
        },
      },
    },
    teaserOptions: {
      configSet: TeaserOptions,
      configValues: {},
    },
    emptyContentText: {
      configSet: Text,
      configValues: {
        style: {
          textAlign: 'center',
        },
      },
    },
    emptyContentContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '110px',
          padding: '20px',
        },
      },
    },
    singleBetsList: {
      configSet: SingleBetsList,
      configValues: {},
    },
    optionsContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexGrow: 0,
        },
      },
    },
    betslipSettingsContainer: {
      configSet: FlexPane,
      configValues: {
        createStackingContext: true,
        style: {
          alignItems: 'center',
        },
      },
    },
    betslipSettings: {
      configSet: BetslipSettings,
      configValues: {},
    },
    systemBetsList: {
      configSet: SystemBetsList,
      configValues: {},
    },
    bankersToggleButton: {
      configSet: ToggleButton,
      configValues: {
        mainContainer: {
          itemSpacing: '8px',
          style: {
            padding: '0 8px 0 0',
            alignItems: 'center',
            textAlign: 'right',
          },
        },
        style: {
          disabled: {
            container: {
              opacity: 1,
              cursor: 'auto',
            },
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
